import React, { useEffect, useState, useContext } from 'react'

import { DataContext } from '../context/DataContext'
import TileView from './dataview/TileView'
import { getOverallView, getLearningLabsView, getSimulationsView, HomeViews } from '../Reporting'
import LoadingIndicator from './LoadingIndicator'
import { isDebug } from '../App.config'
import { PrimaryHeader } from '../styles/Styles'


const Home: React.FC = () => {
    const { allStudents, simProfiles, labProfiles } = useContext(DataContext)
    const [dataViews, setDataViews] = useState<HomeViews>()

    useEffect(() => {
        if (!allStudents && !simProfiles && !labProfiles) return
        isDebug && console.log('Home DataViews effect.')

        const views = {
            overall: getOverallView(allStudents, simProfiles, labProfiles),
            labs: getLearningLabsView(labProfiles),
            sims: getSimulationsView(simProfiles)
        }
        setDataViews(views)

    }, [allStudents, labProfiles, simProfiles])

    if (!dataViews) return <LoadingIndicator loading={true} timeout={25} />

    return (
        <>
            <PrimaryHeader variant={'h4'}>
                {`Overall Data`}
            </PrimaryHeader>
            <TileView dataTiles={dataViews.overall} />
            <TileView title={`Learning Labs Data`} dataTiles={dataViews.labs} />
            <TileView title={`Troubleshooting Simulations Data`} dataTiles={dataViews.sims} />
        </>
    )
}

export default Home
